import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { Loader } from "components/Loader";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import moment from "moment";
import { Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { customGetAPI } from "services/utils/CustomAPI";
import {
  CustomButton,
  InfoMessage,
} from "components/CustomComponents/CustomButton";
import { CustomAutoComplete } from "components/CustomComponents";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { AssignWorkUnit } from "./AssignWorkUint";
import DateRangePicker from "react-bootstrap-daterangepicker";
import DateRangeIcon from "@mui/icons-material/DateRange";
import {
  formKeyText,
  tooltipStyleProps,
  rowEndStyle,
} from "services/constants/Styles";
import { showToast } from "services/utils/Status";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";

export const Daily = ({
  loading,
  dailyShiftList,
  updateDailyShift,
  selectCurrentDate,
  shiftGrpError,
  setGrpNameError,
  openDialog,
  setOpenDialog,
  filterChanges,
  setFilterChanges,
  departmentIdValue,
  setFetchWeekly,
  workUnitCheck,
  departmentNames,
  masterDataForSearch,
}) => {
  const [page, setLeavePage] = useState(0);
  const [rowsPerPage, setLeaveRowsPerPage] = useState(25);
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const handleChangePage = (event, newPage) => {
    setLeavePage(newPage);
  };
  const [editWorkUnitDialogBox, setOpenEditWorkUnitDialogBox] = useState(false);
  const [userShiftsDet, setUserShiftsDet] = useState([]);
  const [curShiftDetail, setCurShiftDetail] = useState([]);
  const [shiftName, setShiftName] = useState("");
  const [shiftId, setShiftId] = useState("");
  const [shiftGrpData, setSftGrpData] = useState([]);
  const [triggerApi, setTriggerApi] = useState(false);
  const [weeklyScreen, setWeeklyScreen] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [calculateInnerWidth, setCalculateInnerWidth] = useState(
    window.innerWidth < 1400
  );
  const containerRef = useRef(null);
  const [shiftBased, setShiftBased] = useState(
    departmentNames === "All" ? "All Department" : "Current Department"
  );

  const [latestPayDate, setLatestPayDate] = useState(null);
  const [disable, setDisable] = useState(true);
  const [selectedDates, setSelectedDates] = useState([]);
  const [getPayDate, setGetPayDate] = useState(false);
  const [getDepartmentId, setGetDepartmentId] = useState("");
  const [state, setState] = useState(() => {
    return {
      start: selectCurrentDate,
      end: selectCurrentDate,
    };
  });

  useEffect(() => {
    setShiftBased(
      departmentNames === "All" ? "All Department" : "Current Department"
    );
  }, [departmentNames]);

  const { start, end } = state;
  const handleCallback = (start, end) => {
    setState({ start, end });
    const dates = [];
    const currentDate = moment(start);

    while (currentDate.isSameOrBefore(end, "day")) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate.add(1, "day");
    }
    setSelectedDates(dates);
    setShiftName("");
    setDisable(false);
  };

  const label = start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");

  useEffect(() => {
    if (getPayDate) {
      setSelectedDates([selectCurrentDate.format("YYYY-MM-DD")]);
      setState({
        start: selectCurrentDate,
        end: selectCurrentDate,
      });
      setGetPayDate(false);
    }
  }, [getPayDate, selectCurrentDate]);

  useEffect(() => {
    const handleResize = () => {
      setCalculateInnerWidth(window.innerWidth < 1400);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleChangeRowsPerPage = (event) => {
    setLeaveRowsPerPage(parseInt(event.target.value, 10));
    setLeavePage(0);
  };

  const sortedDailyShiftList = dailyShiftList?.sort((a, b) => {
    const assignNameA = a.user_name || "";
    const assignNameB = b.user_name || "";
    return assignNameA.localeCompare(assignNameB, undefined, {
      numeric: true,
    });
  });

  useEffect(() => {
    if (filterChanges) {
      setFilterChanges(false);
      setLeavePage(0);
    }
  }, [filterChanges, setFilterChanges]);

  const hasDatesBeforeLatestPayDate = selectedDates.some((date) =>
    moment(date).isSameOrBefore(moment(latestPayDate, "DD-MM-YYYY"), "day")
  );

  const updateIndividualShift = async () => {
    const shift_assignments = selectedDates.map((date) => ({
      shift_id: shiftId ?? curShiftDetail?.shift_id,
      date: date,
      is_week_off: shiftName === "Weekoff",
      unassigned: curShiftDetail?.shift_name === "Unassigned",
    }));
    if (shiftName !== "" && !hasDatesBeforeLatestPayDate) {
      updateDailyShift(userShiftsDet?.user_id, shift_assignments);
      setOpenDialog(false);
      setShiftBased(
        departmentNames === "All" ? "All Department" : "Current Department"
      );
      setSelectedDates([selectCurrentDate.format("YYYY-MM-DD")]);
    } else if (shiftName === "") {
      setGrpNameError(true);
    } else {
      showToast("error", "Selected detes must after previous payrun date");
    }
  };

  const handleShiftGroup = (event, data) => {
    if (data) {
      setShiftName(data?.label);
      setShiftId(data?.shift_id);
      setDisable(false);
    } else {
      setShiftName("");
      setShiftId("");
    }
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      const url =
        shiftBased === "Current Department"
          ? `${domain}deparment-shift-filter/?department_id=${
              shiftBased === "Current Department"
                ? getDepartmentId
                : departmentIdValue
            }&date=${selectDate.format("YYYY-MM-DD")}`
          : `${domain}all/shift-filter/`;
      const res = await customGetAPI(url);
      if (res.ok) {
        setSftGrpData(res?.responseDetails);
        setShiftBased(
          departmentNames === "All" ? "All Department" : "Current Department"
        );
      }
      //  else {
      //   setSftGrpData([]);
      //   setShiftName("");
      // }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
      setTriggerApi(false);
    }
  }, [
    departmentIdValue,
    departmentNames,
    domain,
    getDepartmentId,
    selectCurrentDate,
    selectDate,
    shiftBased,
    triggerApi,
    userShiftsDet.user_id,
  ]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const selectShiftBased = (event) => {
    setShiftBased(event.target.value);
    setTriggerApi(true);
    setDisable(false);
    setGrpNameError(false);
  };

  const clearValues = () => {
    setOpenDialog(false);
    setGrpNameError(false);
    setDisable(true);
    setSelectedDates([selectCurrentDate.format("YYYY-MM-DD")]);
    setShiftBased(
      departmentNames === "All" ? "All Department" : "Current Department"
    );
  };

  return (
    <React.Fragment>
      {loading ? (
        <Mui.Box>
          <Loader info="Loading..." />
        </Mui.Box>
      ) : (
        <Mui.Grid container>
          <Mui.TableContainer
            ref={containerRef}
            component={Mui.Paper}
            sx={{
              mt: 1,
              width: "100%",
              border: 1,
              borderRadius: 5,
              borderColor: themes.primary,
              maxHeight: calculateInnerWidth ? 380 : 690,
              ml: 1,
              mr: 1,
            }}
          >
            <Mui.Table>
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow>
                  <Mui.TableCell
                    sx={{
                      color: themes.headLine,
                      fontWeight: "bold",
                      width: "20%",
                    }}
                    align="left"
                  >
                    Name
                  </Mui.TableCell>
                  <Mui.TableCell
                    sx={{
                      color: themes.headLine,
                      fontWeight: "bold",
                    }}
                    align="center"
                  >
                    Shift & Time
                  </Mui.TableCell>
                  {workUnitCheck && (
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                      align="center"
                    >
                      WorkUnit
                    </Mui.TableCell>
                  )}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {sortedDailyShiftList?.length === 0 ? (
                  <InfoMessage dataLength={masterDataForSearch} />
                ) : (
                  sortedDailyShiftList
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((shiftList, index) => (
                      <React.Fragment>
                        {shiftList?.shifts.map((shift, i) => (
                          <Mui.TableRow key={index} sx={{ cursor: "pointer" }}>
                            <Mui.TableCell
                              sx={{ border: 1, borderColor: themes.primary }}
                            >
                              <Mui.Stack direction="Row">
                                <Mui.Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={shiftList?.user_name
                                    ?.charAt(0)
                                    .toUpperCase()}
                                  src={shiftList?.image_url ?? optionalAvathar}
                                />
                                <Mui.Typography
                                  sx={{
                                    paddingLeft: 1,
                                  }}
                                >
                                  {shiftList.user_name}
                                </Mui.Typography>
                              </Mui.Stack>
                            </Mui.TableCell>

                            <Mui.TableCell
                              sx={{
                                fontSize: 13,
                                border: 1,
                                borderColor: themes.primary,
                                backgroundColor: shift?.color_code,
                              }}
                              onClick={() => {
                                if (
                                  checkEditorPermission(
                                    userScreenAccess?.module_details,
                                    "Shift",
                                    "Shift"
                                  )
                                ) {
                                  setUserShiftsDet(shiftList);
                                  setCurShiftDetail(shift);
                                  setShiftName(
                                    shift?.shift_name === "Unassigned"
                                      ? ""
                                      : shift?.shift_name
                                  );
                                  setShiftId(shift?.shift_id);
                                  setSelectDate(selectCurrentDate);
                                  setLatestPayDate(shiftList?.latest_pay_date);
                                  setGetDepartmentId(shiftList?.department_id);
                                  setGetPayDate(true);
                                  setOpenDialog(true);
                                  setTriggerApi(true);
                                } else {
                                  showToast(
                                    "error",
                                    "Access denied: You are not authorized to change shift"
                                  );
                                }
                              }}
                            >
                              <Mui.Stack
                                direction="column"
                                width={"100%"}
                                sx={{
                                  alignItems: "center",
                                }}
                              >
                                {shift?.shift_name === null ||
                                shift?.shift_name === "Weekoff" ? (
                                  ""
                                ) : shift?.shift_start_time &&
                                  shift?.shift_end_time ? (
                                  <>
                                    <Mui.Typography sx={{ fontSize: 12 }}>
                                      {moment(
                                        shift?.shift_start_time,
                                        "HH:mm:SS"
                                      ).format("h:mm a")}
                                      {" to "}{" "}
                                      {moment(
                                        shift?.shift_end_time,
                                        "HH:mm:SS"
                                      ).format("h:mm a")}
                                    </Mui.Typography>
                                  </>
                                ) : null}
                                <Mui.Typography
                                  sx={{
                                    fontSize: 12,
                                    fontWeight: "bold",
                                    padding: "4px 8px",
                                    borderRadius: "4px",
                                    display: "inline-block",
                                  }}
                                >
                                  {shift?.shift_name
                                    ? shift?.shift_name
                                    : "Not Joined"}
                                </Mui.Typography>
                              </Mui.Stack>
                            </Mui.TableCell>
                            {workUnitCheck && (
                              <Mui.TableCell
                                sx={{ border: 1, borderColor: themes.primary }}
                                align="center"
                                onClick={() => {
                                  if (
                                    shift?.additional_units?.total_count !==
                                      0 &&
                                    shift?.default_units?.total_count !== 0 &&
                                    shift?.shift_name !== "Weekoff"
                                  ) {
                                    setOpenEditWorkUnitDialogBox(true);
                                    setUserShiftsDet(shiftList);
                                    setCurShiftDetail(shift);
                                    setShiftName(shift?.shift_name);
                                    setShiftId(shift?.shift_id);
                                    setWeeklyScreen(true);
                                  }
                                }}
                              >
                                {(shift?.additional_units?.total_count === 0 &&
                                  shift?.default_units?.total_count === 0) ||
                                shift?.shift_name === "Weekoff" ? (
                                  <Mui.Typography>N/A</Mui.Typography>
                                ) : (
                                  <Mui.Stack>
                                    <Mui.Typography
                                      sx={{
                                        textAlign: "center",
                                        fontSize: {
                                          xs: 12,
                                          sm: 12,
                                          md: 15,
                                          lg: 15,
                                        },
                                      }}
                                    >
                                      <Mui.Tooltip
                                        arrow
                                        slotProps={tooltipStyleProps}
                                        title={
                                          <>
                                            <Mui.Typography
                                              sx={{ fontSize: 15 }}
                                            >
                                              Default Work Unit
                                            </Mui.Typography>
                                            {shift?.default_units?.details?.map(
                                              (data) => (
                                                <Mui.Grid
                                                  container
                                                  sx={{
                                                    borderTop: `2px solid ${themes.sidebarDivider}`,
                                                    borderBottom: `2px solid ${themes.sidebarDivider}`,
                                                  }}
                                                >
                                                  <Mui.Grid xs={6}>
                                                    <Mui.Typography>
                                                      {data?.work_unit_name}
                                                    </Mui.Typography>
                                                  </Mui.Grid>
                                                  <Mui.Grid xs={6}>
                                                    <Mui.Typography>
                                                      {data?.number_of_units}
                                                    </Mui.Typography>
                                                  </Mui.Grid>
                                                </Mui.Grid>
                                              )
                                            )}
                                          </>
                                        }
                                      >
                                        {shift?.default_units?.total_count
                                          ? shift?.default_units?.total_count
                                          : 0}
                                        {" + "}
                                      </Mui.Tooltip>
                                      <Mui.Tooltip
                                        arrow
                                        slotProps={tooltipStyleProps}
                                        title={
                                          <>
                                            <Mui.Typography
                                              sx={{ fontSize: 15 }}
                                            >
                                              Additional Work Unit
                                            </Mui.Typography>
                                            {shift?.additional_units?.details?.map(
                                              (data) => (
                                                <Mui.Grid
                                                  container
                                                  sx={{
                                                    borderTop: `2px solid ${themes.sidebarDivider}`,
                                                    borderBottom: `2px solid ${themes.sidebarDivider}`,
                                                  }}
                                                >
                                                  <Mui.Grid xs={6}>
                                                    <Mui.Typography>
                                                      {data?.work_unit_name}
                                                    </Mui.Typography>
                                                  </Mui.Grid>
                                                  <Mui.Grid xs={6}>
                                                    <Mui.Typography>
                                                      {data?.number_of_units}
                                                    </Mui.Typography>
                                                  </Mui.Grid>
                                                </Mui.Grid>
                                              )
                                            )}
                                          </>
                                        }
                                      >
                                        {shift?.additional_units?.total_count
                                          ? shift?.additional_units?.total_count
                                          : 0}
                                      </Mui.Tooltip>
                                    </Mui.Typography>
                                  </Mui.Stack>
                                )}
                              </Mui.TableCell>
                            )}
                          </Mui.TableRow>
                        ))}
                      </React.Fragment>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          <Mui.Grid
            container
            sx={{
              ...rowEndStyle,
            }}
          >
            {sortedDailyShiftList?.length > 25 && (
              <Mui.TablePagination
                className="custom-pagination"
                component="div"
                rowsPerPageOptions={[25, 50, 75, 100]}
                count={sortedDailyShiftList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Mui.Grid>
        </Mui.Grid>
      )}

      {openDialog ? (
        <div>
          <GlobalDialogBox
            handleCloseDialog={() => {
              clearValues();
            }}
            open={openDialog}
            title="Edit Shift Details"
            minWidth={800}
          >
            <Mui.Grid container>
              <Mui.Grid container>
                <Mui.Grid item xs={5.5}>
                  <Mui.Typography sx={formKeyText}>
                    Employee Name &nbsp;{" "}
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Displays the name of the employee whose shift details are being modified."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item xs={6}>
                  <Mui.Typography
                    sx={{ fontWeight: 700, fontSize: 18, mt: 1.7 }}
                  >
                    {userShiftsDet?.user_name}
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ mt: 1.5 }}>
                <Mui.Grid item xs={5.5}>
                  <Mui.Typography sx={formKeyText}>
                    Date&nbsp;{" "}
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Choose a single date to update the shift for that specific day."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item xs={6}>
                  <DateRangePicker
                    initialSettings={{
                      startDate: start.toDate(),
                      endDate: end.toDate(),
                      applyClass: "custom-apply-btn",
                      cancelClass: "custom-cancel-btn",
                      minDate: latestPayDate
                        ? moment(latestPayDate, "DD-MM-YYYY")
                            .add(1, "day")
                            .toDate()
                        : false,
                      locale: {
                        format: "DD/MM/YYYY",
                      },
                    }}
                    onCallback={handleCallback}
                  >
                    <Mui.TextField
                      id="reportrange"
                      variant="outlined"
                      label=""
                      placeholder="Select a date range"
                      value={label}
                      size="small"
                      InputProps={{
                        readOnly: true,
                        notched: false,
                        endAdornment: (
                          <Mui.InputAdornment position="end">
                            <Mui.IconButton>
                              <DateRangeIcon />
                            </Mui.IconButton>
                          </Mui.InputAdornment>
                        ),
                      }}
                      InputLabelProps={{ shrink: true, required: true }}
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          legend: {
                            display: "none",
                          },
                        },
                      }}
                    />
                  </DateRangePicker>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ mt: 1.5 }}>
                <Mui.Grid item xs={5.5}>
                  <Mui.Typography sx={formKeyText}>
                    {" "}
                    Shift based on &nbsp;{" "}
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Choose whether to view shift options based on the employee’s current department or across all departments."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={6} container sx={{ mt: 0.5 }}>
                  <Mui.RadioGroup
                    row
                    onChange={selectShiftBased}
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={shiftBased}
                    name="radio-buttons-group"
                  >
                    <Mui.FormControlLabel
                      label="Current Department"
                      value="Current Department"
                      control={<Mui.Radio />}
                    />

                    <Mui.FormControlLabel
                      label="All Department"
                      value="All Department"
                      control={<Mui.Radio />}
                    />
                  </Mui.RadioGroup>
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ mt: 1.5 }}>
                <Mui.Grid item xs={5.5}>
                  <Mui.Typography sx={formKeyText}>
                    Shift Name &nbsp;{" "}
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Select the appropriate shift to assign for the chosen date."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid item xs={6}>
                  <CustomAutoComplete
                    dataList={shiftGrpData
                      ?.filter((obj) => obj?.shift_name !== shiftName)
                      .map((obj) => ({
                        ...obj,
                        label: obj?.shift_name,
                      }))}
                    selectedValue={shiftName}
                    updateDataFunction={handleShiftGroup}
                    placeHolder="Select shift group name"
                  />
                  {shiftGrpError ? (
                    <h6
                      style={{
                        paddingTop: 2,
                        color: themes.helperTextColor,
                        fontSize: 12,
                      }}
                    >
                      Shift name is required
                    </h6>
                  ) : null}
                </Mui.Grid>
              </Mui.Grid>

              <Mui.Grid container sx={{ mt: 1 }}>
                <Mui.Grid xs={8.9}></Mui.Grid>
                <Mui.Grid xs={3}>
                  <CustomButton
                    actionFuntion={() => {
                      clearValues();
                    }}
                    actionName="Cancel"
                    typeName="button"
                  />
                  &nbsp;
                  <CustomButtonWithOutLoader
                    actionName="Update"
                    typeName="submit"
                    actionFuntion={updateIndividualShift}
                    disableAction={disable}
                  />
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
          </GlobalDialogBox>
        </div>
      ) : null}

      {editWorkUnitDialogBox ? (
        <AssignWorkUnit
          userShiftsDet={userShiftsDet}
          curShiftDetail={curShiftDetail}
          shiftName={shiftName}
          setOpenEditWorkUnitDialogBox={setOpenEditWorkUnitDialogBox}
          editWorkUnitDialogBox={editWorkUnitDialogBox}
          setFetchWeekly={setFetchWeekly}
          setWeeklyScreen={setWeeklyScreen}
          weeklyScreen={weeklyScreen}
        />
      ) : null}
    </React.Fragment>
  );
};
